import { apiClient } from '@shared/api/client';
import { ApiResponse } from '@shared/api/api.types';
import { BugReportDTO, CreateBugReportDTO } from '../dtos';

// Bug Report API
export const bugReportApi = {
  // Submit bug report
  async submitBugReport(data: CreateBugReportDTO): Promise<ApiResponse<BugReportDTO>> {
    return apiClient.post<BugReportDTO>('/bug-reports', data);
  },
};
